import { Calendar, momentLocalizer } from "react-big-calendar";
import { Card, Button, Space, Form, Drawer, Select, DatePicker } from "antd";
import { useMemo, useState, useRef, useEffect } from "react";
import moment from "moment";
import "./Medicaid.scss";
import classNames from "classnames";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import CustomToolBar from "./CustomToolBar";
import MedicaidAgenda from "./MedicaidAgenda";
import useStatesHook from "./useStatesHook";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

const localizer = momentLocalizer(moment);

const Medicaid = () => {
  const [date, setDate] = useState(new Date());
  const [defaultView, setDefaultView] = useState("month");
  const [view, setView] = useState(defaultView);
  const [currentDate, setCurrentDate] = useState(moment().startOf("day"));
  const [filterFlag, setFilterFlag] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [medMeetingData, setMeetings] = useState([]);
  const [meetingFilters, setMeetingFilters] = useState({
    meetingType: [],
    states: [],
    drugClasses: [],
    date: null,
  });
  const currentDateRef = useRef();
  const navigate = useNavigate();
  currentDateRef.current = currentDate || new Date();
  const currentView = useRef();
  currentView.current = defaultView;

  const windowSize$ = useSharedState();
  const [form] = Form.useForm();

  useEffect(() => {
    fetchMeetings();
  }, [meetingFilters]);

  const getLists = useStatesHook();
  const { statesList, drugClasses, meetingType } = getLists;

  const convertDate = (date) => {
    return new Date(date);
  };

  const applyMeetingFilters = () => {
    const filters = form.getFieldsValue(true);
    filters['date'] = filterDate;
    setMeetingFilters(filters);
    setFilterFlag(false);
  };

  const fetchMeetings = () => {
    ServiceUtils.postRequest("medicaidConferencesInfo", meetingFilters).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let medMeetingsData = JSON.parse(
            JSON.stringify(response?.data?.data)
          );
          medMeetingsData?.map((sch, index) => {
            medMeetingsData[index].start = convertDate(
              medMeetingsData[index].start
            );
            medMeetingsData[index].end = convertDate(
              medMeetingsData[index].end
            );
          });
          setMeetings(medMeetingsData);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const hanldeViewChange = (newView) => {
    setDefaultView(newView);
    setView(newView);
  };

  const handleNavigate = (action, date) => {
    if (action === "TODAY") {
      setCurrentDate(moment().startOf("day"));
    } else if (action === "DATE") {
      setCurrentDate(new Date(date));
    } else if (action === "PREV") {
      setCurrentDate((prevDate) =>
        moment(prevDate).subtract(1, currentView.current).toDate()
      );
    } else if (action === "NEXT") {
      setCurrentDate((prevDate) =>
        moment(prevDate).add(1, currentView.current).toDate()
      );
    }
  };

  const openFilterDrawer = () => {
    setFilterFlag(true);
  };

  const onCloseFilter = () => {
    setFilterFlag(false);
  };

  const components = useMemo(
    () => ({
      toolbar: (props) => (
        <CustomToolBar
          handleNavigate={handleNavigate}
          updateView={hanldeViewChange}
          openFilterDrawer={openFilterDrawer}
          view={view}
          defaultView={currentView.current}
          currentDate={currentDateRef}
          {...props}
        />
      ),
    }),
    []
  );

  const columns = [
    {
      label: "Medicaid",
      link: "",
    },
  ];

  const eventPropsHandler = (event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: event.color,
        border: "none",
        padding: "2px 6px",
        boxShadow: "none",
      },
    };
  };

  const onDrillDown = (e) => {
    console.log(e, "event fored on drill down");
  };

  const onSelectEvent = (e) => {
    console.log(e, "event fired on select event");
  };

  const onShowMore = (moreEvents, date) => {
    console.log(moreEvents, "event fired on show more");
    console.log(date, "event fired on show more");
  };

  const handleCalender = (event, value, key) => {
    setFilterDate(value)
  };

  return (
    <div className="details-root" data-test="details-container">
      {filterFlag && (
        <Drawer
          title="Enter filter details"
          // width={720}
          size="default"
          onClose={onCloseFilter}
          open={filterFlag}
          styles={{
            body: {
              paddingBottom: 80,
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingTop: "0px",
            },
          }}
          footer={
            <Space>
              <Button
                style={{ background: "#000000" }}
                type="primary"
                onClick={applyMeetingFilters}
              >
                Apply
              </Button>
              <Button onClick={onCloseFilter}>Cancel</Button>
              {/* <Button onClick={onResetFilters}>Reset</Button> */}
            </Space>
          }
        >
          <Form form={form} layout="vertical" hideRequiredMark>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                States
              </label>
              <Form.Item name="states">
                <Select
                  mode="multiple"
                  options={statesList}
                  placeholder="Select drug classes"
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "5px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Drug Classes
              </label>
              <Form.Item name="drugClasses">
                <Select
                  placeholder="Select Drug Classes"
                  mode="multiple"
                  options={drugClasses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Meeting Type
              </label>
              <Form.Item name="meetingType">
                <Select
                  placeholder="Select Meeting"
                  mode="multiple"
                  options={meetingType}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Date
              </label>
              <Form.Item name="date">
                <DatePicker
                  // defaultValue={syncinputs?.start_date && dayjs(syncinputs?.start_date)}
                  value={filterDate && dayjs(filterDate)}
                  name="start_date"
                  style={{ width: "100%" }}
                  // showTime
                  // format="YYYY-MM-DD"
                  placeholder="Select Date"
                  onChange={(date, dateString) => {
                    handleCalender(date, dateString, "date");
                  }}
                  // onOk={onOk}
                />
              </Form.Item>
            </div>
          </Form>
        </Drawer>
      )}
      <div className="container">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>

        <Card>
          <div
            className={classNames("calendar-height calender-big", {
              "margin-classs":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "margin-class":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            {view && view === "month" && (
              <Calendar
                localizer={localizer}
                defaultView={defaultView}
                events={medMeetingData}
                startAccessor="start"
                endAccessor="end"
                date={date}
                view={view}
                onNavigate={setDate}
                onView={setView}
                components={components}
                eventPropGetter={eventPropsHandler}
                drilldownView="null"
                onDrillDown={onDrillDown}
                onSelectEvent={onSelectEvent}
                // onShowMore={onShowMore}
                // onShowMore={(moreEvents, date) => {
                //   console.log("Only +more events 👉", moreEvents);
                //   console.log("Clicked date 👉", date);
                // }}
                popup
              />
            )}
            {view && view === "agenda" && (
              <MedicaidAgenda
                events={medMeetingData}
                updateView={hanldeViewChange}
                currentDate={currentDateRef}
                view={view}
              />
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Medicaid;
